import React, { FC }                                                  from 'react';
import { InputProps, SemanticShorthandItem, TextArea, TextAreaProps } from 'semantic-ui-react';
import { useField, useFormikContext }                                 from 'formik';
import { FieldWrapper }                                               from './FieldWrapper';
import { FieldDescription }                                           from './FieldDescription';
import { FormikUseFieldType }                                         from '../../../../types';

interface TextAreaFieldProps extends TextAreaProps {
	label?: string,
	descriptionText?: string,
	includeFieldWrapper?: boolean,
	includeErrorMessage?: boolean,
	autocomplete?: boolean,
	
	[ additionalProps: string ]: any
}

const defaultProps: TextAreaFieldProps = {
	label:               null,
	descriptionText:     null,
	includeFieldWrapper: true,
	includeErrorMessage: true,
	autocomplete:        false,
}

const TextAreaField: FC<TextAreaFieldProps> = ( _props ) => {
	
	let {
		    label,
		    autocomplete,
		    descriptionText,
		    includeFieldWrapper,
		    includeErrorMessage,
		    ...props
	    } = _props;
	
	// useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
	// which we can spread on <input> and also replace ErrorMessage entirely.
	let formik = useFormikContext();
	
	const [ field, meta ] = ( formik ? useField( props.name ) : [ { name: props.name }, {} ] ) as FormikUseFieldType;
	
	let showErrors  = ( meta.touched && meta.error ),
	    Wrapper: FC = includeFieldWrapper ? FieldWrapper : React.Fragment;
	
	// sanitize null values
	field.value = field.value ?? '';
	
	// merge input props, html props, and field props
	let inputProps: SemanticShorthandItem<InputProps> = {
		...field,
		...props,
		autoComplete: autocomplete ? 'on' : 'off',
	}
	
	return (
		
		<Wrapper { ...{ showErrors, includeErrorMessage, meta, field } }>
			
			{ label && <label htmlFor={ props.id || props.name }>{ label }</label> }
			
			{ descriptionText && <FieldDescription>{ descriptionText }</FieldDescription> }
			
			<TextArea { ...inputProps } />
		
		</Wrapper>
	);
};

TextAreaField.defaultProps = defaultProps;

export { TextAreaField }
